/* SilverShine — Motor de conversión mm <-> quilates (ct) por PESO REAL.
   Fuente única: la usan la página "Guía de tamaños" (ss-calculadora-piedras) y el
   configurador de la ficha (ss-configurador). Si cambias un dato, cambia en ambos.

   Fórmulas estándar de estimación de peso (industria / GIA, medidas en mm):
     Redondo ........ diámetro² × profundidad × 0.0061
     Ovalado ........ ((largo+ancho)/2)² × profundidad × 0.0062
     Resto .......... largo × ancho × profundidad × factor del corte
   Factores por proporción largo/ancho (L/A):
     Esmeralda/Radiante 1:1 .0080 · 1.5:1 .0092 · 2:1 .0100 · 2.5:1 .0106
     Pera 1.25:1 .0061 · 1.5:1 .0060 · 2:1 .0057
     Marquesa 1.5:1 .00565 · 2:1 .00580 · 2.5:1 .00585 · 3:1 .00595
     Princesa .0083 · Asscher .0083 · Cojín .00815 · Corazón .0059
   Las fórmulas están calibradas para diamante (densidad 3.52). Otra gema:
     peso = peso_diamante × relación (REL)
   Diamante (natural o de laboratorio) 1.00 · Circonia cúbica 5.8/3.52 = 1.65
   (densidad 5.6–6.0) · Moissanita 0.88: su densidad es 3.22 (GIA) y además se talla
   algo más baja; el estándar de la industria es 6.5 mm redonda = 0.88 ct de peso real
   (= 1.00 ct "equivalente diamante"). Usamos PESO REAL (decisión de Jose).
   Gemas de color (solo configurador), por densidad: corindón 4.00, esmeralda 2.72,
   aguamarina 2.69, morganita 2.80, cuarzo/amatista 2.65, larimar 2.80, ágata 2.60.
   Proporciones típicas (L/A y profundidad como % del ancho) para pasar de ct a mm.
   Resultado = estimación (±5–10 %): el peso exacto depende de la talla de cada piedra. */
(function(w){
  if (w.SSGemas) return;

  function lerp(tab, r){
    if (r <= tab[0][0]) return tab[0][1];
    for (var i = 1; i < tab.length; i++){
      if (r <= tab[i][0]){
        var a = tab[i-1], b = tab[i];
        return a[1] + (b[1]-a[1]) * (r-a[0]) / (b[0]-a[0]);
      }
    }
    return tab[tab.length-1][1];
  }
  var T_ESM = [[1,.0080],[1.5,.0092],[2,.0100],[2.5,.0106]];
  var T_PERA = [[1.25,.0061],[1.5,.0060],[2,.0057]];
  var T_MARQ = [[1.5,.00565],[2,.00580],[2.5,.00585],[3,.00595]];

  /* f(r) = factor según L/A · r = L/A típico · d = profundidad / ancho · tipo */
  var CUTS = {
    'Redondo':   { t:'round', r:1,    d:.60,  f:function(){return .0061;}, alargado:false },
    'Ovalado':   { t:'avg',   r:1.40, d:.60,  f:function(){return .0062;}, alargado:true },
    'Princesa':  { t:'lwd',   r:1,    d:.70,  f:function(){return .0083;}, alargado:false },
    'Esmeralda': { t:'lwd',   r:1.45, d:.65,  f:function(r){return lerp(T_ESM,r);}, alargado:true },
    'Cojín':     { t:'lwd',   r:1.05, d:.65,  f:function(){return .00815;}, alargado:false },
    'Pera':      { t:'lwd',   r:1.50, d:.62,  f:function(r){return lerp(T_PERA,r);}, alargado:true },
    'Marquesa':  { t:'lwd',   r:2.00, d:.62,  f:function(r){return lerp(T_MARQ,r);}, alargado:true },
    'Radiante':  { t:'lwd',   r:1.25, d:.66,  f:function(r){return lerp(T_ESM,r);}, alargado:true },
    'Corazón':   { t:'lwd',   r:1,    d:.60,  f:function(){return .0059;}, alargado:false },
    'Asscher':   { t:'lwd',   r:1,    d:.66,  f:function(){return .0083;}, alargado:false }
  };

  var D = 3.52;
  var REL = {
    'diamante':1, 'moissanita':.88, 'circonia':5.8/D,
    'zafiro':4.00/D, 'rubí':4.00/D, 'rubi':4.00/D, 'esmeralda':2.72/D, 'aguamarina':2.69/D,
    'morganita':2.80/D, 'amatista':2.65/D, 'larimar':2.80/D, 'ágata':2.60/D, 'agata':2.60/D
  };
  function relOf(name){
    var n = String(name||'').toLowerCase();
    if (n.indexOf('circonia') > -1 || n.indexOf('zirconia') > -1) return REL.circonia;
    if (n.indexOf('moissanit') > -1 || n.indexOf('moisanit') > -1) return REL.moissanita;
    for (var k in REL){ if (n.indexOf(k) > -1) return REL[k]; }
    return 1;
  }
  function cutOf(c){ return CUTS[c] || CUTS['Redondo']; }

  /* mm -> ct. L = largo (o diámetro), A = ancho (si falta, se usa la proporción típica) */
  function ct(cut, stone, L, A){
    var c = cutOf(cut); L = +L; A = +A;
    if (!(L > 0)) return 0;
    if (!c.alargado) A = (A > 0) ? A : L / c.r;
    else if (!(A > 0)) A = L / c.r;
    if (A > L){ var t = L; L = A; A = t; }
    var r = L / A, D = A * c.d, w;
    if (c.t === 'round') w = Math.pow((L + A) / 2, 2) * D * c.f(r);
    else if (c.t === 'avg') w = Math.pow((L + A) / 2, 2) * D * c.f(r);
    else w = L * A * D * c.f(r);
    return w * relOf(stone);
  }

  /* ct -> mm con la proporción típica del corte. Devuelve {L, A} */
  function mm(cut, stone, carats){
    var c = cutOf(cut), q = +carats;
    if (!(q > 0)) return { L:0, A:0 };
    var k = ct(cut, stone, c.r, 1); /* peso de una piedra con ancho = 1 mm */
    var A = Math.cbrt(q / k);
    return { L: A * c.r, A: A };
  }

  function fmtMM(cut, d){
    var c = cutOf(cut);
    if (!c.alargado) return d.L.toFixed(1) + ' mm';
    return d.L.toFixed(1) + ' × ' + d.A.toFixed(1) + ' mm';
  }

  /* Silueta del corte en una caja 100×100 (vista superior, proporción típica) */
  function shape(cut){
    var a=[],i,t;
    function oct(w,h){return [[50-w*0.32,50-h],[50+w*0.32,50-h],[50+w,50-h*0.32],[50+w,50+h*0.32],[50+w*0.32,50+h],[50-w*0.32,50+h],[50-w,50+h*0.32],[50-w,50-h*0.32]];}
    if(cut==='Ovalado'){for(i=0;i<40;i++){t=i/40*6.2832;a.push([50+33*Math.cos(t),50+46*Math.sin(t)]);}}
    else if(cut==='Cojín'){for(i=0;i<40;i++){t=i/40*6.2832;var cx=Math.sign(Math.cos(t))*Math.pow(Math.abs(Math.cos(t)),.55),cy=Math.sign(Math.sin(t))*Math.pow(Math.abs(Math.sin(t)),.55);a.push([50+44*cx,50+46*cy]);}}
    else if(cut==='Princesa'){a=[[6,6],[94,6],[94,94],[6,94]];}
    else if(cut==='Radiante'){a=oct(37,46);}
    else if(cut==='Esmeralda'){a=oct(32,46);}
    else if(cut==='Asscher'){a=oct(45,45);}
    else if(cut==='Pera'){a=[[50,4],[58,9],[67,19],[75,33],[80,50],[80,64],[74,80],[63,90],[50,94],[37,90],[26,80],[20,64],[20,50],[25,33],[33,19],[42,9]];}
    else if(cut==='Marquesa'){a=[[50,3],[58,12],[67,28],[73,50],[67,72],[58,88],[50,97],[42,88],[33,72],[27,50],[33,28],[42,12]];}
    else if(cut==='Corazón'){a=[[50,22],[60,10],[75,6],[89,14],[94,30],[88,50],[74,68],[50,92],[26,68],[12,50],[6,30],[11,14],[25,6],[40,10]];}
    else {for(i=0;i<48;i++){t=i/48*6.2832;a.push([50+46*Math.cos(t),50+46*Math.sin(t)]);}}
    return a.map(function(p){return p[0].toFixed(1)+','+p[1].toFixed(1);}).join(' ');
  }

  w.SSGemas = { shape:shape, ct:ct, mm:mm, fmtMM:fmtMM, rel:relOf, cut:cutOf, CUTS:CUTS };
})(window);
